// store/formSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  brandProfile: {
    // ── Section 1: Basic Info ──────────────────────────────────────────────
    brandName:            "",
    companyWebsite:       "",
    industries:           [],
    otherIndustry:        "",
    targetAudiences:      [],
    otherTargetAudience:  "",
    contentLanguage:      "English",

    // ── Section 2: Mission & Values ───────────────────────────────────────
    brandMission:         "",
    brandArchetype:       [],
    otherBrandArchetype:  "",
    brandValues:          [],
    otherBrandValue:      "",
    brandPersonality:     [],
    otherBrandPersonality:"",
    writingVoice:         [],
    otherWritingVoice:    "",
    avoidContent:         [],
    otherAvoidContent:    "",

    // ── Section 3: Voice & Tone ───────────────────────────────────────────
    emotionalToneRange:   "Balanced",
    sentenceComplexity:   "Medium",

    // ── Section 4: Products & Services ───────────────────────────────────
    services:             [""],
    valueProposition:     "",
    positioningStyle:     [],
    otherPositioningStyle:"",
    problemSolved:        "",
    competitors:          "",
    competitiveAdvantage: "",

    // ── Section 5: Visual Identity ────────────────────────────────────────
    visualStyle:          [],
    otherVisualStyle:     "",
    colorPalette: {
      primary:    "#ffffff",
      secondary:  "#ffffff",
      background: "#ffffff",
      accent:     "#ffffff",
    },
    logo:          null,   // File object — intentionally NOT persisted to localStorage
    logoPlacement: "Bottom-right",

    // ── Section 6: Platform Preferences ──────────────────────────────────
    platformPreferences:      {},   // { instagram, facebook, linkedIn, twitter, newsletter, blog }
    platformPreferencesOther: {},   // custom "Other" values per platform

    // ── Section 7: Campaign Context ───────────────────────────────────────
    campaignContext: {
      currentCampaignName:   "",
      primaryEmotionalTheme: "",
      seasonalContext:       "",
    },

    // ── Section 8: Brand Strategy & AI Intelligence (Q01–Q12) ─────────────
    // Required
    brandPromise:          "",   // Q01
    brandEnemy:            "",   // Q02
    coreBeliefs:           "",   // Q03
    primaryCtaPerPlatform: "",   // Q10
    claimsNotAllowed:      "",   // Q12

    // Optional
    voiceReferenceExamples:      "",  // Q04
    exactAudienceLanguage:       "",  // Q05
    signaturePhrases:            "",  // Q06
    audienceFears:               "",  // Q07
    customerTransformationStory: "",  // Q08
    socialProofData:             "",  // Q09
    funnelStageFocus:            "",  // Q11
    funnelStageBreakdown:        "",  // Q11b
  },
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.auth = { ...state.auth, ...action.payload };
    },

    updateBrandProfile: (state, action) => {
      // Shallow merge — spreads the incoming partial update over existing state.
      // Deep nested objects (colorPalette, campaignContext, etc.) must be passed
      // as complete objects from the caller (setNestedField handles this).
      state.brandProfile = { ...state.brandProfile, ...action.payload };
    },

    resetForm: () => initialState,

    hydrate: (state, action) => {
      // Merge persisted profile on top of initialState so any new fields
      // added since the user last visited still get their defaults.
      if (action.payload?.form?.brandProfile) {
        state.brandProfile = {
          ...initialState.brandProfile,
          ...action.payload.form.brandProfile,
          // Never restore a stale File object from storage — keep as null
          logo: null,
        };
      }
      if (action.payload?.auth) {
        state.auth = { ...state.auth, ...action.payload.auth };
      }
    },
  },
});

export const { setAuth, updateBrandProfile, resetForm, hydrate } = formSlice.actions;
export default formSlice.reducer;